import { useForm } from "react-hook-form";

import { StoreSelectOptionsProps } from "./types";
import { useStoresAndShopkeepersStore } from "@repo/core/stores/storesAndShopkeepers";
import { ProposalsResource } from "@repo/core/services/resources/proposals";
import { apiInstance } from "@repo/core/services/instances/api";
import useAuthStore from "@repo/core/stores/auth";

const proposalsResource = new ProposalsResource(apiInstance);

export const useStoreSelectOptionsController = ({
  onClose,
  onSelectStoreSuccess
}: StoreSelectOptionsProps) => {
  const { user } = useAuthStore();
  const {
    availableStores,
    availableShopkeepers,
    setSelectedStore,
    setSelectedShopkeeper,
    selectedStore,
    selectedShopkeeper,
    setAvailableStores,
    hasMoreThanOneShopkeeper,
    hasMoreThanOneStore
  } = useStoresAndShopkeepersStore();

  const selectedStoreIndex = availableStores.findIndex(
    (store) =>
      store.codigoEstabelecimento === selectedStore?.codigoEstabelecimento
  );

  const selectedShopkeeperIndex = availableShopkeepers.findIndex(
    (shopkeeper) => shopkeeper.lojista === selectedShopkeeper?.lojista
  );

  const { control, handleSubmit } = useForm<{
    shopkeeper: string;
    store: string;
  }>({
    values: {
      shopkeeper: selectedShopkeeperIndex.toString(),
      store: selectedStoreIndex.toString()
    }
  });

  const onChangeShopkeeper = async (shopkeeperIndex: string) => {
    const indexToNumber = Number(shopkeeperIndex);
    const shopkeeperId = availableShopkeepers[indexToNumber].lojista;
    const response = await proposalsResource.fetchStores(
      user?.token || "",
      shopkeeperId
    );
    setAvailableStores(response.data);
  };

  const onSubmitForm = handleSubmit(
    (data: { shopkeeper: string; store: string }) => {
      const shopkeeperIndex = Number(data.shopkeeper);
      const storeIndex = Number(data.store);
      const shopkeeperData = availableShopkeepers[shopkeeperIndex];
      const storeData = availableStores[storeIndex];
      setSelectedShopkeeper(shopkeeperData);
      setSelectedStore(storeData);
      onClose?.();
      onSelectStoreSuccess?.();
    }
  );

  return {
    control,
    onSubmitForm,
    availableShopkeepers,
    availableStores,
    onChangeShopkeeper,
    hasMoreThanOneShopkeeper,
    hasMoreThanOneStore
  };
};
